import { Route } from "react-router-dom";
import PropTypes from "prop-types";
import Layout from "../pages/_layout/Layout";
import AuthHandler from "../auth/AuthHandler";

export default function RouteWrapper({
  component: Component,
  isPrivate,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={(props) => (
        // WGI - Disable auth for development
        <AuthHandler isPrivate={isPrivate}>
          <Layout>
            <Component {...props} />
          </Layout>
        </AuthHandler>
      )}
    />
  );
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: true,
};
